import { CASES } from './constants';

export const updateJobTasks = (payload) => {
    return { type: CASES.UPDATE_JOB_TASKS, payload };
};

export const updateJobTasksForm = ({ key, data }) => {
    return {
        type: CASES.UPDATE_JOB_TASKS_FORM,
        payload: { key, data },
    };
};

export const clearJobTasks = () => {
    return { type: CASES.CLEAR_JOB_TASKS, payload: {} };
};
